import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import {isEmpty} from 'lodash';

const accordionStyle = makeStyles(theme => ({
    accordion: {
        marginBottom: 5,
        borderRadius: '6px 6px 0px 0px',
        position: 'initial',
        '&:last-of-type': {
            background: 'transparent',
        },
    },
    formBackground: {
        backgroundColor: `${theme.palette.inPatient.accordionBackground} !important`,
        border: `solid 1px ${theme.palette.inPatient.accordionBorder}`,
    },
    shadow: {
        boxShadow: `0px ${theme.palette.mode === 'light' ? 1 : 0}px ${theme.palette.mode === 'light' ? 4 : 0}px 0px rgba(0, 0, 0, 0.25)`,
    },
    header: {
        backgroundColor: theme.palette.accordion.backgroundColorRefresh,
        marginBottom: 3,
        borderRadius: '6px 6px 0px 0px',
        overflow: 'hidden',
        '&.hide': {
            marginBottom: 0,
        },
        '&.fromForm': {
            borderRadius: 6,
        },
        '&.withSecondLine': {
            backgroundColor: "#3D3E40"
        }
    },
    body: {
        backgroundColor: theme.palette.accordion.backgroundBodyRefresh,
        '&.margin': {
            marginTop: 3,
        },
    },
    heading: {
        fontWeight: 400,
        fontSize: 16,
        fontFamily: 'Inter',
    },
    divider: {
        borderBottomWidth: 2,
        borderRadius: 5,
        margin: '0 5px',
    },
}));

const AgyleAccordion = (props) => {
    const classes = accordionStyle();

    return (
        <Accordion
            expanded={props.expanded}
            onChange={props.onChange}
            className={clsx(classes.accordion, props.addShadow && classes.shadow)}
            disabled={props.disabled}
            disableGutters
            TransitionProps={{unmountOnExit: props.unmountOnExit}}
            square
            sx={{borderRadius: '8px 8px 0px 0px'}}
            style={{marginBottom: 5}}
        >
            {/*<AccordionSummary expandIcon={<ExpandMoreIcon/>} className={classes.header} sx={{backgroundColor: 'transparent'}}>*/}
            <AccordionSummary
                expandIcon={props.onChange ? <ExpandMoreIcon/> : null}
                className={clsx(
                    classes.header,
                    (!props.unmountOnExit && !props.expanded) && 'hide',
                    props.formBackground && classes.formBackground,
                    (props.formBackground && !props.expanded) && 'fromForm',
                    props.secondLine && 'withSecondLine',
                )}
                sx={{
                    '.MuiAccordionSummary-content': {
                        flexDirection: props.secondLine? 'column': 'row'
                    }
                }}
            >
                <Typography className={clsx(classes.heading, props.headingStyle)}>
                    {props.label}
                </Typography>

                {props.secondLabel &&
                    <Typography style={{paddingLeft: 5}} className={clsx(classes.heading, props.secondHeadingStyle)}>
                        {props.secondLabel}
                    </Typography>
                }
                {props.secondLine &&
                    <div>
                        {props.secondLine}
                    </div>
                }
            </AccordionSummary>

            {props.children &&
                <AccordionDetails
                    className={clsx(
                        classes.body,
                        props.bodyStyle,
                        props.formBackground && classes.formBackground,
                    )}
                >
                    {props.children}
                </AccordionDetails>
            }

            {!isEmpty(props.details) && props.details.map((el, index) => (
                <AccordionDetails
                    key={el?.id || Math.random()}
                    className={clsx(
                        classes.body,
                        index !== 0 && 'margin',
                        props.formBackground && classes.formBackground,
                    )}
                >
                    {el}
                </AccordionDetails>
            ))}
        </Accordion>
    );
};

export default AgyleAccordion;

AgyleAccordion.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    secondLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    children: PropTypes.any,
    expanded: PropTypes.bool,
    unmountOnExit: PropTypes.bool,
    formBackground: PropTypes.bool,
    disabled: PropTypes.bool,
    addShadow: PropTypes.bool,
    onChange: PropTypes.func,
    headingStyle: PropTypes.any,
    bodyStyle: PropTypes.any,
    secondHeadingStyle: PropTypes.string,
    details: PropTypes.array,
};

AgyleAccordion.defaultProps = {
    label: '',
    expanded: false,
    addShadow: false,
    disabled: false,
    unmountOnExit: true,
    formBackground: true,
    details: [],
};